export const ORGANIZATION_FEATURES_TITLES = {
  STREAMS: "Streams",
  TAGS: "Tags",
  COLLAB_CENTRAL: "Collab Central",
  COLLAB_CENTRAL_CLASSIC: "Collab Central Classic",
  FOLLOWER_MAIL_INTERVAL: "Follower Mail Interval",
  TIME_SHEETS: "Time Sheets",
  COST_CENTER: "Cost Center",
  BUSINESS_UNITS: "Business Units",
  INTEGRATIONS: "Integrations",
  DEPARTMENTS: "Departments",
  CHATBOT: "Chatbot",
  OFFICE_LOCATION: "Office Location",
  DIRECTORY: "Directory",
  CUSTOM_FIELD_SETTINGS: "Custom Field Settings", // Backend name - used for matching
  JOB_ROLE: "Job Role",
  API_INTEGRATION: "API Integration",
  USER_GROUPS: "User Groups",
  USER_PROFILE_LAYOUT: "User Profile Layout",
  PROJECT_PROFILE_LAYOUT: "Project Profile Layout",
  MISCELLANEOUS: "Miscellaneous",
};

/** sessionStorage: set when opening Miscellaneous from User Groups (reporting manager hint link) */
export const SESSION_KEY_HIGHLIGHT_REPORTING_HIERARCHY = "orgFeaturesHighlightReportingHierarchy";

/**
 * Mapping from backend feature names to frontend display names
 * Used to display different names in UI while keeping backend compatibility
 */
export const FEATURE_DISPLAY_NAMES = {
  [ORGANIZATION_FEATURES_TITLES.CUSTOM_FIELD_SETTINGS]: "Global Chips",
  [ORGANIZATION_FEATURES_TITLES.JOB_ROLE]: "Job Roles",
  [ORGANIZATION_FEATURES_TITLES.TIME_SHEETS]: "Time Blocks",
  [ORGANIZATION_FEATURES_TITLES.OFFICE_LOCATION]: "Office Locations",
  [ORGANIZATION_FEATURES_TITLES.COST_CENTER]: "Cost Centers",
};

export const ORGANIZATION_FEATURES_ALTERNATE_NAMES = {
  [ORGANIZATION_FEATURES_TITLES.CHATBOT]: ["Chatbot", "AI"],
  [ORGANIZATION_FEATURES_TITLES.OFFICE_LOCATION]: ["Office Location"],
  [ORGANIZATION_FEATURES_TITLES.COLLAB_CENTRAL]: ["Center", "Hub", "Sync", "Partner"],
  [ORGANIZATION_FEATURES_TITLES.COST_CENTER]: ["Costing", "Center", "CC", "Expense", "Spending"],
  [ORGANIZATION_FEATURES_TITLES.BUSINESS_UNITS]: ["Business", "Unit", "BU", "Operation", "Division"],
  [ORGANIZATION_FEATURES_TITLES.TIME_SHEETS]: ["Time", "Sheets", "Timing", "Shift", "Track"],
  [ORGANIZATION_FEATURES_TITLES.DEPARTMENTS]: ["Dept", "Unit", "Section", "Group"],
  [ORGANIZATION_FEATURES_TITLES.TAGS]: ["Label", "hashtags", "mark", "topic"],
  [ORGANIZATION_FEATURES_TITLES.FOLLOWER_MAIL_INTERVAL]: ["Mail", "Interval", "Time", "hours"],
  [ORGANIZATION_FEATURES_TITLES.MISCELLANEOUS]: ["Miscellaneous", "Misc"],
};

export const ALWAYS_ENABLED_FEATURES = [
  ORGANIZATION_FEATURES_TITLES.TAGS,
  ORGANIZATION_FEATURES_TITLES.PROFILE_SETTINGS,
  ORGANIZATION_FEATURES_TITLES.STREAMS,
  ORGANIZATION_FEATURES_TITLES.MISCELLANEOUS,
];

export const MIN_CFA_NAME_LENGTH = 3;
export const MAX_CFA_NAME_LENGTH = 30;
export const MIN_CFA_REMARK_LENGTH = 3;
export const MAX_CFA_REMARK_LENGTH = 80;
